import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { CreateAccountAPI } from '../api/createaccount/createaccountapi';
import { CreateAccountRequest } from '../api/createaccount/createaccountrequest';
import { CreateAccountResponse } from '../api/createaccount/createaccountresponse';
import { ForgotPasswordAPI } from '../api/forgotpassword/forgotpasswordapi';
import { ForgotPasswordRequest } from '../api/forgotpassword/forgotpasswordrequest';
import { ForgotPasswordResponse } from '../api/forgotpassword/forgotpasswordresponse';
import { GenerateOTPAPI } from '../api/otp/generateotp/generateotpapi';
import { GenerateOTPRequest } from '../api/otp/generateotp/generateotprequest';
import { GenerateOTPResponse } from '../api/otp/generateotp/generateotpresponse';
import { OTPCheckAPI } from '../api/otp/otpcheck/otpcheckapi';
import { OTPCheckRequest } from '../api/otp/otpcheck/otpcheckrequest';
import { OTPCheckResponse } from '../api/otp/otpcheck/otpcheckresponse';
import { SendOTPAPI } from '../api/otp/sendotp/sendotpapi';
import { SendOTPRequest } from '../api/otp/sendotp/sendotprequest';
import { SendOTPResponse } from '../api/otp/sendotp/sendotpresponse';
import { PasswordValidationAPI } from '../api/passwordvalidation/passwordvalidationapi';
import { PasswordValidationRequest } from '../api/passwordvalidation/passwordvalidationrequest';
import { PasswordValidationResponse } from '../api/passwordvalidation/passwordvalidationresponse';
import { SecurityTokenAPI } from '../api/securitytoken/securitytokenapi';
import { SecurityTokenRequest } from '../api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse } from '../api/securitytoken/securitytokenresponse';
import { SignupCategoriesAPI } from '../api/signupcategories/signupcategoriesapi';
import { SignupCategoriesRequest } from '../api/signupcategories/signupcategoriesrequest';
import { SignupCategoriesResponse } from '../api/signupcategories/signupcategoriesresponse';
import { SubscriberValidationAPI } from '../api/subscribervalidation/subscribervalidationapi';
import { SubscriberValidationRequest } from '../api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse } from '../api/subscribervalidation/subscribervalidationresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { CreateAccountAPIProcessorImpl } from '../processor/createaccountapiprocessor';
import { ForgotPasswordAPIProcessorImpl } from '../processor/forgotpasswordapiprocessor';
import { GenerateOTPAPIProcessorImpl } from '../processor/generateotpapiprocessor';
import { OTPCheckAPIProcessorImpl } from '../processor/otpcheckapiprocessor';
import { PasswordValidationAPIProcessorImpl } from '../processor/passwordvalidationapiprocessor';
import { SecurityTokenAPIProcessorImpl } from '../processor/securitytokenapiprocessor';
import { SendOTPAPIProcessorImpl } from '../processor/sendotpapiprocessor';
import { SignupCategoriesAPIProcessorImpl } from '../processor/signupcategoriesapiprocessor';
import { SubscriberValidationAPIProcessorImpl } from '../processor/subscribervalidationapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { SettingsRequest } from '../api/settings/settingsrequest';
import { SettingsResponse } from '../api/settings/settingsresponse';
import { SettingsAPIProcessorImpl } from '../processor/settingsapiprocessor';
import { SettingsAPI } from '../api/settings/settingsapi';
import { LoginRequest } from '../api/login/loginrequest';
import { LoginResponse } from '../api/login/loginresponse';
import { LoginAPI } from '../api/login/loginapi';
import { LoginAPIProcessorImpl } from '../processor/loginapiprocessor';
import { SubscriberValidationSignUpAPIProcessorImpl } from '../processor/subscribervalidationsignupapiprocessor';
import { ConfirmOTPRequest } from '../api/otp/confirmotp/confirmotprequest';
import { ConfirmOTPResponse } from '../api/otp/confirmotp/confirmotpresponse';
import { ConfirmOTPAPI } from '../api/otp/confirmotp/confirmotpapi';
import { ConfirmOtpAPIProcessorImpl } from '../processor/confirmotpprocessor';
import { PasswordValidationCCRequest } from '../api/passwordvalidationcc/passwordvalidationccrequest';
import { PasswordValidationCCResponse } from '../api/passwordvalidationcc/passwordvalidationccresponse';
import { PasswordValidationCCAPIProcessorImpl } from '../processor/passwordvalidationccapiprocessor';
import { PasswordValidationCCAPI } from '../api/passwordvalidationcc/passwordvalidationccapi';

export class LoginProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(LoginProcessorFactory.name);
    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    validateSubscriber():APIProcessor<SubscriberValidationRequest, SubscriberValidationResponse>
    {
        this.logger.log("validateSubscriber() invoked");
        return new SubscriberValidationAPIProcessorImpl(this.getContext(), new SubscriberValidationAPI(this.getHttpClient(), this.getContext()));
    }

    validateSignupSubscriber():APIProcessor<SubscriberValidationRequest, SubscriberValidationResponse>
    {
        this.logger.log("validateSubscriber() invoked");
        return new SubscriberValidationSignUpAPIProcessorImpl(this.getContext(), new SubscriberValidationAPI(this.getHttpClient(), this.getContext()));
    }

    login():APIProcessor<LoginRequest, LoginResponse>
    {
        this.logger.log("validateSubscriber() invoked");
        return new LoginAPIProcessorImpl(this.getContext(), new LoginAPI(this.getHttpClient(), this.getContext()));
    }
    
    getSecurityToken():APIProcessor<SecurityTokenRequest, SecurityTokenResponse>
    {
        this.logger.log("getSecurityToken() invoked");
        return new SecurityTokenAPIProcessorImpl(this.getContext(), new SecurityTokenAPI(this.getHttpClient(), this.getContext()));
    }

    confirmOtp():APIProcessor<ConfirmOTPRequest, ConfirmOTPResponse>
    {
        this.logger.log("getSecurityToken() invoked");
        return new ConfirmOtpAPIProcessorImpl(this.getContext(), new ConfirmOTPAPI(this.getHttpClient(), this.getContext()));
    }
    
    validatePassword():APIProcessor<PasswordValidationRequest, PasswordValidationResponse>
    {
        this.logger.log("validatePassword() invoked");
        return new PasswordValidationAPIProcessorImpl(this.getContext(), new PasswordValidationAPI(this.getHttpClient(), this.getContext()));
    }

    validateCCPassword():APIProcessor<PasswordValidationCCRequest, PasswordValidationCCResponse>
    {
        this.logger.log("validateCCPassword() invoked");
        return new PasswordValidationCCAPIProcessorImpl(this.getContext(), new PasswordValidationCCAPI(this.getHttpClient(), this.getContext()));
    }
    
    generateOTP():APIProcessor<GenerateOTPRequest, GenerateOTPResponse>
    {
        this.logger.log("generateOTP() invoked");
        return new GenerateOTPAPIProcessorImpl(this.getContext(), new GenerateOTPAPI(this.getHttpClient(), this.getContext()));
    }
    
    otpCheck():APIProcessor<OTPCheckRequest, OTPCheckResponse>
    {
        this.logger.log("otpCheck() invoked");
        return new OTPCheckAPIProcessorImpl(this.getContext(), new OTPCheckAPI(this.getHttpClient(), this.getContext()));
    }

    sendOTP():APIProcessor<SendOTPRequest, SendOTPResponse>
    {
        this.logger.log("sendOTP() invoked");
        return new SendOTPAPIProcessorImpl(this.getContext(), new SendOTPAPI(this.getHttpClient(), this.getContext()));
    }
    
    createAccount():APIProcessor<CreateAccountRequest, CreateAccountResponse>
    {
        this.logger.log("createAccount() invoked");
        return new CreateAccountAPIProcessorImpl(this.getContext(), new CreateAccountAPI(this.getHttpClient(), this.getContext()));
    }
    
    resetPassword():APIProcessor<ForgotPasswordRequest, ForgotPasswordResponse>
    {
        this.logger.log("resetPassword() invoked");
        return new ForgotPasswordAPIProcessorImpl(this.getContext(), new ForgotPasswordAPI(this.getHttpClient(), this.getContext()));
    }

    getSettings():APIProcessor<SettingsRequest, SettingsResponse>
    {
        this.logger.log("resetPassword() invoked");
        return new SettingsAPIProcessorImpl(this.getContext(), new SettingsAPI(this.getHttpClient(), this.getContext()));
    }

    signupCategories():APIProcessor<SignupCategoriesRequest, SignupCategoriesResponse>
    {
        this.logger.log("signupCategories() invoked");
        return new SignupCategoriesAPIProcessorImpl(this.getContext(), new SignupCategoriesAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory.tsx